export const TABLE_DETAIL_TYPE = Symbol('detail');
